import { Component } from 'react'
import { connect } from 'react-redux'
import { sidebarOpenSelector } from 'selectors'
import styled, { css } from 'styled-components/macro'
import { rgba } from 'polished'
import { media } from 'styles/mixins'
import { Link, withRouter } from 'react-router-dom'
import { h6, body2, overline, subtitle2 } from 'styles/mixins/textstyles'
import { Overline } from 'components/layout/text'
import colors from 'styles/colors'
import Loader from 'components/misc/Loader'
import { ExternalLink } from 'components/layout/links'
import { Icon } from 'roadie-ui'

const SidebarFrame = styled.div`
  width: 23rem;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 3.2rem;
  padding-top: 2rem;
  padding-left: 2rem;
  position: fixed;
  top: 0;
  left: -50rem;
  bottom: 0;
  transition: left 750ms ease;

  word-break: break-word;

  ${(props) =>
    props.modalOpen &&
    css`
      left: 0;
    `}

  ${media.desktop`
    padding-top: 0;
    padding-left: 0;
    position: static;
  `}

  ${media.ultrawide`
    padding-top: 0;
    padding-left: 0;
    position: static;
  `}
`

const SidebarModalBG = styled.div`
  transition: all 350ms ease;
  background: ${(props) => rgba(props.theme.colors.white, 0)};

  ${(props) =>
    props.modalOpen &&
    css`
      background: ${(props) => rgba(props.theme.colors.white, 0.95)};
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
    `}
`

const ModalClose = styled(Icon.ChevronLeft).attrs({ $color: 'neutral-dark' })`
  display: none;

  ${(props) =>
    props.modalOpen &&
    css`
      display: block;
      position: absolute;
      right: 3rem;
      top: 3rem;
      width: 4rem;
      cursor: pointer;
    `}
`

export const NameHeading = styled.div`
  ${(props) => h6(props.theme.colors.black)}
  margin-top: .8rem;
`

export const NameSubHeading = styled.div`
  ${(props) => body2(props.theme.colors.black, 'medium')}
  margin-bottom: .4rem;
`

export const Section = styled.nav`
  margin-bottom: 4rem;
  display: block;

  > ${Overline}:first-child {
    margin-bottom: 0.8rem;
  }

  h4 {
    ${(props) => overline(props.theme.colors.black, 'medium')}
    padding: 0;
  }
`

const activeClassName = 'sidebar-link-active'
const StyledSidebarLink = styled(Link)`
  ${(props) => subtitle2(props.theme.colors.black, 'medium')}

  display: block;
  padding: 0.8rem 0;

  &.${activeClassName} {
    color: ${(props) => props.theme.colors.primaryBase};
    font-weight: bold;
  }
`

const sidebarLinkStyle = css`
  ${subtitle2()}

  display: block;
  padding: 0.8rem 0;
  display: flex;
  align-items: center;
`

export const SidebarExternalLink = styled(ExternalLink)`
  ${sidebarLinkStyle}
`

class HistoryLink extends Component {
  state = {
    active: this.props.location.pathname.startsWith(this.getToPath()),
  }

  getToPath() {
    const { to } = this.props
    return typeof to === 'string' ? to : to.pathname
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(({ pathname }) => {
      this.setState({
        active: pathname.startsWith(this.getToPath()),
      })
    })
  }

  componentWillUnmount() {
    this.unlisten()
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { staticContext, ...props } = this.props
    return <StyledSidebarLink className={this.state.active && activeClassName} {...props} />
  }
}

export const SidebarLink = withRouter(HistoryLink)

export const SidebarLoader = styled(Loader).attrs({ background: 'none', foreground: colors.primaryBase, size: 20 })`
  margin-left: 0.5rem;
`

class Sidebar extends Component {
  handleBgClick = (event) => {
    if (event.target === this.sidebarBg) {
      this.props.dispatch({ type: 'SET_SIDEBAR_OPEN', open: false })
    }
  }

  handleClose = (event) => {
    event.preventDefault()
    this.props.dispatch({ type: 'SET_SIDEBAR_OPEN', open: false })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.sidebarFrame && nextProps.sidebarOpen !== this.props.sidebarOpen) {
      this.sidebarFrame.scrollTop = 0
    }
  }

  render() {
    return (
      <SidebarModalBG
        ref={(el) => (this.sidebarBg = el)}
        modalOpen={this.props.sidebarOpen}
        onClick={this.handleBgClick}
      >
        <ModalClose modalOpen={this.props.sidebarOpen} onClick={this.handleClose} />
        <SidebarFrame ref={(el) => (this.sidebarFrame = el)} modalOpen={this.props.sidebarOpen}>
          {this.props.children}
        </SidebarFrame>
      </SidebarModalBG>
    )
  }
}

export default connect(sidebarOpenSelector)(Sidebar)
